module.exports = __webpack_public_path__ + "static/media/3.bb5e6a60.JPG";